import { Redirect } from 'react-router-dom';
import Login from '../pages/authentication/login';
import Register from '../pages/authentication/register';
import UserList from '../pages/settings/user-list';
import Dashboard from '../pages/operation/dashboard';
import ReviewComment from '../pages/operation/review-comment';
import Memo from '../pages/operation/memo';
import PrefinalContractLegal from '../pages/operation/prefinal-contract-legal';
import PrefinalContractUser from '../pages/operation/prefinal-contract-user';
import PrefinalContractReject from '../pages/operation/prefinal-contract-reject';
import FinalContract from '../pages/operation/final-contract';
import SignedContract from '../pages/operation/signed-contract';
import CreateRequests from '../pages/request/create-requests';
import CreateRequest from '../pages/request/create-request';
import RequestLists from '../pages/request/request-lists';
import RequestFormList from '../pages/request/request-form-list';
import RequestDetail from '../pages/request/request-detail';
import AssignWork from "../pages/operation/assign-work";
import AcceptAssign from "../pages/operation/accept-assign";
import SummaryRequest from '../pages/operation/summary-request';
import AllTypeRequest from '../pages/request/all-type-request';

const authRoutes = [
  { path: "/dashboard", component: Dashboard },
  { path: "/users", component: UserList },
  { path: "/assign/:id", component: AssignWork },
  { path: "/accept/:id", component: AcceptAssign },
  { path: "/review-comment/:id", component: ReviewComment },
  { path: "/memo/:id", component: Memo },
  { path: "/prefinal-legal/:id", component: PrefinalContractLegal },
  { path: "/prefinal-user/:id", component: PrefinalContractUser },
  { path: "/prefinal-reject/:id", component: PrefinalContractReject },
  { path: "/final-contract/:id", component: FinalContract },
  { path: "/signed-contract/:id", component: SignedContract },
  { path: "/create-request/:tablename", component: CreateRequest },
  { path: "/create-requests", component: CreateRequests },
  { path: "/requests", component: RequestLists },
  { path: "/request-form/:tablename", component: RequestFormList },
  { path: "/request/:idRequest", component: RequestDetail },
  { path: "/all-type-request", component: AllTypeRequest },
  { path: "/summary-request/:id", component: SummaryRequest },
  // { path: "/add-user", component: UserList},
  // { path: "/user-detail/:id", component: UserList},
  {
      path: "/",
      expect: true,
      component: () => <Redirect to="/requests" />,
  }
];

const publicRoutes = [
  { path: "/login", component: Login },
  { path: "/register/:email", component: Register },
];

export { authRoutes, publicRoutes };